module.exports = __webpack_public_path__ + "img/ico-box-closed.57a4d4fb.svg";